import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=585a1f0c&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=585a1f0c&prod&lang%2C=true&SubscriptionPanel=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a1f0c",
  null
  
)

export default component.exports